import { useQuery } from "@apollo/client/react";
import { createFileRoute } from "@tanstack/react-router";
import { GetFoldersDocument } from "../generated/graphql";
import type { GetFoldersQuery, GetFoldersQueryVariables } from "../generated/graphql";

export const Route = createFileRoute("/test-graphql")({
  component: TestGraphQL,
});

function TestGraphQL() {
  const { data, loading, error } = useQuery<GetFoldersQuery, GetFoldersQueryVariables>(
    GetFoldersDocument,
    {
      variables: { parentId: null },
    }
  );

  return (
    <div style={{ padding: "2rem" }}>
      <h1>GraphQL Connection Test</h1>

      <div style={{ marginTop: "1rem" }}>
        <h2>Status:</h2>
        {loading && <p>Loading...</p>}
        {error && (
          <div style={{ color: "red" }}>
            <p>Error: {error.message}</p>
            <pre>{JSON.stringify(error, null, 2)}</pre>
          </div>
        )}
        {data && (
          <div style={{ color: "green" }}>
            <p>Connected! Received {data.folders?.edges?.length ?? 0} folders</p>
            <pre>{JSON.stringify(data, null, 2)}</pre>
          </div>
        )}
      </div>
    </div>
  );
}
